export enum SafeHarborResultGridType {
    maximumErpExceeded = 'maximumErpExceeded',
}
